/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserCouponInfoRespVo } from './UserCouponInfoRespVo';
import {
    UserCouponInfoRespVoFromJSON,
    UserCouponInfoRespVoFromJSONTyped,
    UserCouponInfoRespVoToJSON,
    UserCouponInfoRespVoToJSONTyped,
} from './UserCouponInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseUserCouponInfoRespVo
 */
export interface ResponseUserCouponInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserCouponInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserCouponInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {UserCouponInfoRespVo}
     * @memberof ResponseUserCouponInfoRespVo
     */
    data?: UserCouponInfoRespVo;
}

/**
 * Check if a given object implements the ResponseUserCouponInfoRespVo interface.
 */
export function instanceOfResponseUserCouponInfoRespVo(value: object): value is ResponseUserCouponInfoRespVo {
    return true;
}

export function ResponseUserCouponInfoRespVoFromJSON(json: any): ResponseUserCouponInfoRespVo {
    return ResponseUserCouponInfoRespVoFromJSONTyped(json, false);
}

export function ResponseUserCouponInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserCouponInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserCouponInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseUserCouponInfoRespVoToJSON(json: any): ResponseUserCouponInfoRespVo {
    return ResponseUserCouponInfoRespVoToJSONTyped(json, false);
}

export function ResponseUserCouponInfoRespVoToJSONTyped(value?: ResponseUserCouponInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserCouponInfoRespVoToJSON(value['data']),
    };
}

